var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M13 22L19 16L13 10","stroke":"inherit","stroke-width":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }